import { IconAlertErrorOutlined, IconAlertSuccessOutlined } from '@hulu-react-style-components/icons';
import { bem } from 'mission-control-common-components';

import type { CustomPacingRequestedOption } from '../../../../../configs';

const [, element] = bem('custom-pacing-requested-cell');

export const CUSTOM_PACING_REQUESTED_ICON_CONFIG: Record<
  CustomPacingRequestedOption | 'UNRECOGNIZED',
  React.JSX.Element | null
> = Object.freeze({
  DEFAULT: null,
  CP_OPT_IN: <IconAlertSuccessOutlined className={element('success-icon')} />,
  CP_OPT_OUT: <IconAlertErrorOutlined />,
  UNRECOGNIZED: null,
});
